import { html, LitElement, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import '../parts/card';
import '../components/comments';

import style from './status.scss';
import { DATA_STATUS } from '../data/sources';
import { processDesc } from '../shared/parse';
import { getNameFromURL, setTitle, trackPage } from '../shared/utils';

export class StatusPage extends LitElement {

    static get properties() {
        return {
        }
    }

    constructor() {
        super();        
        this.name = '';     
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        trackPage();
        this.name = getNameFromURL();   
        setTitle(this.name);    
    }

    formatType(type){
        if(type === 'Inflict') return 'Inflicted By';
        if(type === 'Add Blessing') return 'Added By';
        if(type === 'Add Enchantment') return 'Added By Enchantment';
        if(type === 'Remove Status') return 'Removed By';
        if(type === 'Start With Status') return 'Start With '+this.name;
        if(type === 'Heal') return 'Heal By '+this.name;
        if(type === 'Set Health') return 'Set Health By '+this.name;
        return type || 'Other References';
    }

    render() {           
        let statuses = DATA_STATUS.filter(s=>s.name===this.name);
        let status = statuses[0]; 
        return html`
            <h1>
                <div class="header-image" style="background-image:url(./images/status/${(status.artwork || '').replace(/ /g, '%20')}.webp);">
                </div> ${status.name}
            </h1>            
            <p>${unsafeHTML(processDesc(status.desc))}</p>
            ${Object.keys(status.cards).map(type=>{
                return html`
                    <h3>${this.formatType(type)}</h3>
                    ${status.cards[type].map(crd=>{
                        return html`
                            <div class="row">
                                <card-part id="${crd}"></card-part>
                            </div>
                        `;
                    })}
                `;
            })}
            <comments-component path=${window.location.pathname}></comments-component>
        `;
    }
}

customElements.define('status-page', StatusPage);